"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const TextTransform_1 = require("./TextTransform");
const XYPosition_1 = require("./XYPosition");
const TextAttr_1 = require("./TextAttr");
exports.TextSchema = DrawingBase_1.DrawingBaseSchema.extend({
    ref: zod_1.z.string().optional(),
    value: zod_1.z.string(),
    type: zod_1.z.literal('text'),
    size: zod_1.z.number().default(1),
    pos: XYPosition_1.XYPositionSchema,
    bounds: XYPosition_1.XYPositionSchema.optional(),
    padding: XYPosition_1.XYPositionSchema.optional(),
    angle: zod_1.z
        .number()
        .nullish()
        .transform((a) => (typeof a !== 'number' ? undefined : a)),
    mirror: zod_1.z.tuple([zod_1.z.boolean(), zod_1.z.boolean()]).optional(),
    justify: zod_1.z.tuple([zod_1.z.number(), zod_1.z.number()]).default([-1, -1]),
    thickness: zod_1.z.number().default(1),
    attr: TextAttr_1.TextAttrSchema.array().optional(),
    ref_designator: zod_1.z.coerce.boolean().optional(),
    val: zod_1.z.coerce.boolean().optional(),
    textAlign: zod_1.z.enum(['right', 'left', 'center']).optional(),
    textTransforms: TextTransform_1.TextTransformSchema.array().optional(),
    isPositionOffset: zod_1.z.boolean().optional(),
    rejustifyOnRotate: zod_1.z.boolean().optional(),
    font: zod_1.z.string().optional(),
    net: zod_1.z.string().optional(),
    wordWrap: zod_1.z.boolean().optional(),
    contrastWithLayer: zod_1.z.boolean().optional(),
    clipToBounds: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=Text.js.map